module.exports = "data:image/png;base64,UklGRvQAAABXRUJQVlA4WAoAAAAQAAAALwAALwAAQUxQSK4AAAABgGJt27Low92rRlbAIXHofyO7ZZrLTER2QB23Nn8ct+47cHefp/xyPhxSREwAGdQrd6B8VxIRQBv6hc2jQihPYkqQ7fPPTsv9/24UkgFLqK8hLeQQQXohHAjw4kpBT/MED18LTdKGLdR5dM/wtIMP5zKuOHZIW56B4doDW2/LDaxwoX2/+LJtCvCRNu2XWAhm2261HWiOr52DaQ8G51w1tG2NS1k7b4/zmpJrwAZWUDggIAAAALABAJ0BKjAAMAAAAAAlpAADyWiYywAA/v/fbtQAAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/p13.png
// module id = W6HR
// module chunks = 1